const findVisibleSwatchImage = (root = document) => {
  const imgs = Array.from(root.querySelectorAll('[data-swatch-image-target] img'));
  return imgs.find((img) => img.offsetParent !== null) || imgs[0] || null;
};

const normalizeValue = (value) =>
  String(value || '')
    .replace(/\s*\(.*\)$/, '')   // remove "(PRE-ORDER)" etc
    .replace(/\s+/g, '')         // remove all spaces
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const getProductRoots = (root = document) => {
  const productRoots = Array.from(root.querySelectorAll('[data-product-root]'));
  return productRoots.length ? productRoots : [root];
};

const getVariantIdForSize = (swatch, sizeKey) => {
  const sizeVariants = swatch.dataset.sizeVariants || '';
  if (!sizeKey || !sizeVariants) return null;
  const token = sizeVariants
    .split('|')
    .find((entry) => entry && entry.startsWith(`${sizeKey}:`));

  if (!token) return null;

  const [, variantId] = token.split(':');
  return variantId || null;
};

const getSelectedSizeValue = (root = document) => {
  const inputs = Array.from(root.querySelectorAll('input[name^=\"options[\"]:checked'));
  for (const input of inputs) {
    if (input.name.toLowerCase().includes('size')) {
      return input.value;
    }
  }
  return null;
};

const applySizeToSwatches = (root, sizeValue) => {
  const sizeKey = normalizeValue(sizeValue);
  const swatchScopes = Array.from(root.querySelectorAll('[data-swatch-scope]'));

  swatchScopes.forEach((scope) => {
    const swatches = Array.from(scope.querySelectorAll('.product-color-swatch[data-href]'));
    swatches.forEach((swatch) => {
      const baseHref = swatch.dataset.href || swatch.getAttribute('href') || '';
      if (sizeValue) {
        try {
          const url = new URL(baseHref, window.location.origin);
          const matchingVariantId = getVariantIdForSize(swatch, sizeKey);
          if (matchingVariantId) {
            url.searchParams.set('variant', matchingVariantId);
          }
          url.searchParams.set('size', sizeValue);
          swatch.setAttribute('href', `${url.pathname}?${url.searchParams.toString()}`);
        } catch {
          swatch.setAttribute('href', baseHref);
        }
      } else {
        swatch.setAttribute('href', baseHref);
      }

      const inStock = swatch.dataset.inStock !== 'false';
      const availableSizes = swatch.dataset.availableSizes || '';

      if (!inStock) {
        swatch.classList.add('is-unavailable');
        swatch.setAttribute('aria-disabled', 'true');
        return;
      }

      if (sizeKey && availableSizes) {
        const isAvailable = availableSizes.includes(`|${sizeKey}|`);
        swatch.classList.toggle('is-unavailable', !isAvailable);
        swatch.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      } else {
        swatch.classList.remove('is-unavailable');
        swatch.removeAttribute('aria-disabled');
      }

    });
  });
};

const applySizeFromUrl = (root = document) => {
  const params = new URLSearchParams(window.location.search);
  const sizeParam = params.get('size');
  if (!sizeParam) return;

  const inputs = Array.from(root.querySelectorAll('input[name^=\"options[\"]'));
  const sizeKey = normalizeValue(sizeParam);
  const sizeInput = inputs.find((input) => input.name.toLowerCase().includes('size') && normalizeValue(input.value) === sizeKey);
  if (sizeInput && !sizeInput.checked) {
    sizeInput.checked = true;
    sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
};

document.addEventListener('change', (e) => {
  const target = e.target;
  if (!(target instanceof HTMLInputElement)) return;
  if (!target.name || !target.name.toLowerCase().includes('size')) return;
  const root = target.closest('[data-product-root]') || document;
  applySizeToSwatches(root, target.value);
});

document.addEventListener('DOMContentLoaded', () => {
  getProductRoots().forEach((root) => {
    applySizeFromUrl(root);
    applySizeToSwatches(root, getSelectedSizeValue(root));
  });
});

document.addEventListener('mouseover', (e) => {
  const swatch = e.target.closest('.product-color-swatch[data-swatch-image]');
  if (!swatch) return;

  const scope = swatch.closest('[data-swatch-scope]');
  if (!scope) return;

  const img = scope.closest('[data-product-card]')?.querySelector('[data-swatch-image-target] img')
    || scope.querySelector('[data-swatch-image-target] img')
    || findVisibleSwatchImage();

  if (!img) return;

  if (!img.dataset.originalSrc) {
    img.dataset.originalSrc = img.getAttribute('src') || '';
    img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    img.dataset.originalAlt = img.getAttribute('alt') || '';
  }

  img.decoding = 'async';
  img.loading = 'eager';
  img.src = swatch.dataset.swatchImage;
  if (swatch.dataset.swatchSrcset) img.srcset = swatch.dataset.swatchSrcset;
  if (swatch.dataset.swatchAlt) img.alt = swatch.dataset.swatchAlt;
});

document.addEventListener('mouseout', (e) => {
  const list = e.target.closest('.product-color-swatches__list');
  if (!list || list.contains(e.relatedTarget)) return;

  const scope = list.closest('[data-swatch-scope]');
  if (!scope) return;

  const img = scope.closest('[data-product-card]')?.querySelector('[data-swatch-image-target] img')
    || scope.querySelector('[data-swatch-image-target] img')
    || findVisibleSwatchImage();

  if (!img || !img.dataset.originalSrc) return;

  img.src = img.dataset.originalSrc;
  img.srcset = img.dataset.originalSrcset;
  img.alt = img.dataset.originalAlt;
});
